/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Rights_ManagedInputs */

const en_val_rights_managed = /** @type {(inputs: Val_Rights_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rights Managed`)
};

const es_val_rights_managed = /** @type {(inputs: Val_Rights_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derechos gestionados`)
};

const fr_val_rights_managed = /** @type {(inputs: Val_Rights_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droits gérés`)
};

const de_val_rights_managed = /** @type {(inputs: Val_Rights_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lizenzpflichtig (Rights Managed)`)
};

const ja_val_rights_managed = /** @type {(inputs: Val_Rights_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライツマネージド`)
};

const zh_val_rights_managed = /** @type {(inputs: Val_Rights_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`版权管理 (Rights Managed)`)
};

const ar_val_rights_managed = /** @type {(inputs: Val_Rights_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدار الحقوق (Rights Managed)`)
};

const id_val_rights_managed = /** @type {(inputs: Val_Rights_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hak Dikelola`)
};

const it_val_rights_managed = /** @type {(inputs: Val_Rights_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rights Managed (Con Restrizioni di Diritti)`)
};

const ru_val_rights_managed = /** @type {(inputs: Val_Rights_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С управляемыми правами`)
};

const pt_val_rights_managed = /** @type {(inputs: Val_Rights_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direitos Gerenciados`)
};

const ko_val_rights_managed = /** @type {(inputs: Val_Rights_ManagedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라이선스 관리(RM)`)
};

/**
* | output |
* | --- |
* | "Rights Managed" |
*
* @param {Val_Rights_ManagedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_rights_managed = /** @type {((inputs?: Val_Rights_ManagedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Rights_ManagedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_rights_managed(inputs)
	if (locale === "es") return es_val_rights_managed(inputs)
	if (locale === "fr") return fr_val_rights_managed(inputs)
	if (locale === "de") return de_val_rights_managed(inputs)
	if (locale === "ja") return ja_val_rights_managed(inputs)
	if (locale === "zh") return zh_val_rights_managed(inputs)
	if (locale === "ar") return ar_val_rights_managed(inputs)
	if (locale === "id") return id_val_rights_managed(inputs)
	if (locale === "it") return it_val_rights_managed(inputs)
	if (locale === "ru") return ru_val_rights_managed(inputs)
	if (locale === "pt") return pt_val_rights_managed(inputs)
	return ko_val_rights_managed(inputs)
});